// ============================================================================
// CANCUN100 — comisionTT.js  (Matemática Top Tours, regla `tt_v2` · Bloque 4)
// ----------------------------------------------------------------------------
// SOLO para agentes tipo_agente === 'top_tours'. Sala de Ventas NO usa nada de
// aquí: su fórmula (40% / RP 80%, 5% con /1.05) sigue intacta en App.js.
//
//   margen_tt           = tFinal − sumNet            (SIN el 5%: Cancun100 lo absorbe)
//   pct                 = premier ? 0.50 : 0.30      (premier = "50-50", basico = "Becados")
//   comision_agente     = max(0, margen_tt × pct)
//   unidades_sup        = Σ unidades por producto (ver unidadesItem)
//   comision_supervisor = 40 × unidades_sup          ($40 MXN por unidad para la supervisora)
//   ganancia_agencia    = margen_tt − comision_agente − comision_supervisor
//   cargo_pasarela_tt   = efectivo ? 0 : tFinal − tFinal/1.05   (solo informativo)
// ============================================================================

// Etiquetas visibles de la modalidad (los valores de la base NO cambian).
export const MODALIDAD_TT = { basico: 'Becados', premier: '50-50' };
export const PCT_TT = { basico: 0.30, premier: 0.50 };
export const TARIFA_SUPERVISOR_TT = 40;
export const REGLA_TT = 'tt_v2';

const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const int = (n) => Math.max(0, parseInt(n, 10) || 0);

export const pctModalidad = (modalidad) => (modalidad === 'premier' ? PCT_TT.premier : PCT_TT.basico);
export const etiquetaModalidad = (modalidad) => MODALIDAD_TT[modalidad === 'premier' ? 'premier' : 'basico'];

// Unidades de supervisión de un producto:
//   tipo 'promo'                     → cantidad de promos
//   tipo 'individual'|'custom'|'combo' → adultos + menores (infantes NO cuentan)
export const unidadesItem = (it) => (it.tipo === 'promo' ? int(it.promos) : int(it.adultos) + int(it.menores));

// Bloque 36 (C): 🎯 RP VENTA POR FUERA en Top Tours = agente 80 % · supervisora 5 % · casa 15 % del margen
// (sin unidades de supervisión; es_rp_por_fuera = true). El resto de modalidades no cambia.
export const PCT_RP_AGENTE = 0.80;
export const PCT_RP_SUPERVISOR = 0.05;

export function calcComisionTT({ tFinal, sumNet, esEfectivo, modalidad, items = [], esRP = false }) {
  const total = Number(tFinal) || 0;
  const margen_tt = r2(total - (Number(sumNet) || 0));
  const pct = esRP ? PCT_RP_AGENTE : pctModalidad(modalidad);
  const comision_agente = r2(Math.max(0, margen_tt * pct));
  const unidades_sup = esRP ? 0 : items.reduce((s, it) => s + unidadesItem(it), 0);
  const comision_supervisor = esRP ? r2(Math.max(0, margen_tt * PCT_RP_SUPERVISOR)) : r2(TARIFA_SUPERVISOR_TT * unidades_sup);
  const ganancia_agencia = r2(margen_tt - comision_agente - comision_supervisor);
  const cargo_pasarela_tt = esEfectivo ? 0 : r2(total - total / 1.05);
  return {
    regla_comision: REGLA_TT,
    modalidad_tt: modalidad === 'premier' ? 'premier' : 'basico',
    pct_agente_tt: pct,
    es_rp_por_fuera: !!esRP,
    margen_tt,
    comision_agente,
    unidades_sup,
    comision_supervisor,
    ganancia_agencia,
    cargo_pasarela_tt,
    // Los dos escenarios que se le muestran al agente (Tarea 3b).
    comision_becados: r2(Math.max(0, margen_tt * PCT_TT.basico)),
    comision_5050: r2(Math.max(0, margen_tt * PCT_TT.premier)),
    bajo_neto: margen_tt < 0,
  };
}

// Escenarios a partir de un margen ya guardado (folios existentes / PDF regenerado).
export const escenariosTT = (margen) => ({
  comision_becados: r2(Math.max(0, (Number(margen) || 0) * PCT_TT.basico)),
  comision_5050: r2(Math.max(0, (Number(margen) || 0) * PCT_TT.premier)),
});
